var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { primitive } from '../../../utils/serializr/schema/inner/primitive';
import { Actor } from '../../../classes/actor/Actor';
import { deserialize, withDefault } from '../../../utils/serializr/serializr';
import { editable, editObservable } from '../../../utils/mobx/decorators/editable';
import { SortableListItems } from './modules/SortableListItems';
export class SortableList extends Actor {
    type = 'sortablelist';
    direction = 'horizontal';
    constructor(init) {
        super(init);
        editObservable(this);
    }
    get question() {
        return this.parent;
    }
    get itemIndex() {
        return this.question.sortableStore.sortableLists.indexOf(this);
    }
    get itemNumber() {
        return this.itemIndex + 1;
    }
    get currentItems() {
        return this.listItems.currentSortableItems;
    }
    get listItems() {
        return new SortableListItems(this);
    }
    static fromSerialized(ser = {}) {
        return deserialize(SortableList, ser);
    }
    static get serializeInfo() {
        return {
            extends: Actor.serializeInfo,
            props: {
                direction: withDefault(primitive, 'horizontal'),
            },
        };
    }
}
__decorate([
    editable()
], SortableList.prototype, "direction", void 0);
__decorate([
    memoize
], SortableList.prototype, "listItems", null);
__decorate([
    memoize
], SortableList, "serializeInfo", null);
